import React from 'react'
import {
  Button,
  Card,
  Modal,
  Col,
  Form,
  Icon,
  Input,
  Row,
  Switch,
  Cascader,
  DatePicker,
  notification,
} from 'antd'
import Moment from 'moment';
import {connect} from 'react-redux'
import {decode} from 'utf8'
import {
  fetchNotifications,createNotification
} from "appRedux/actions/Notifications";

const { TextArea } = Input;
const FormItem = Form.Item

class Basic extends React.Component {
  state = {
    visible: false,
    title: '',
    message: '',
    date_to: '',
    date_from: '',

    validatetitle: '',
    validatemessage: '',

    helptitle: '',
    helpmessage: '',
    imageUrl:'',
    validateStatus: '',
  }

 

  showModal = () => {
    this.setState({
      visible: true,
    })
  }


  handlChangeImage = selectorFiles => {
    const file = selectorFiles[0]
    this.setState({imageUrl: file})
  }


  handleCancel = e => {
    this.setState({
      title: '',
      message: '',
      date_to: '',
      date_from: '',
      imageUrl:'',
    })

    this.props.fetchNotifications()
    this.setState({visible: false})

    if (this.state.title == '') {
      this.setState({validatetitle: '', helptitle: ''})
    }
    if (this.state.message == '') {
      this.setState({validatemessage: '', helpmessage: ''})
    }
    if (this.state.dateFrom !== '' && this.state.dateTo !== ''){
      console.log(this.state);
      this.props.fetchNotifications()
    }
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'La notificación se ha creado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al crear la notificación.',
      })
    }
  }

  onHandleClick = event => {
    event.preventDefault()
    let {title, message, date_to, date_from , imageUrl} = this.state
    if (this.state.validateStatus != 'error') {
      if (title && message && date_to && date_from != '' ) {
        this.props.createNotification(this.state, () => {
          this.props.fetchNotifications()
        })

        this.setState({
          title: '',
          message: '',
          date_to: '',
          date_from: '',
          imageUrl:''
        })

        this.onNotification('success')
      } else {
        if (this.state.title == '') {
          this.setState({
            validatetitle: 'error',
            helptitle: 'Titulo de la notificación es un campo obligatorio.',
          })
        } else {
          this.setState({validatetitle: '', helphelptitleId: ''})
        }
        if (this.state.message == '') {
          this.setState({
            validatemessage: 'error',
            helpmessage: 'Mensaje es un campo obligatorio.',
          })
        } else {
          this.setState({validatemessage: '', helpmessage: ''})
        }
      }
    } else{
      console.log('error validate status')
    }
  }

  onClickDateFrom = (date, dateString) => {
    console.log(dateString);
    this.setState({date_from: dateString})
  }

  onClickDateTo = (date, dateString) => {
    console.log(dateString);
    this.setState({date_to: dateString})
  }

  render() {
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          Enviar notificación
        </Button>
        <Modal
          afterClose={() => this.props.fetchNotifications()}
          okText="Enviar"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Nueva notificación">
            <form onSubmit={this.onHandleClick}>
            <Row className="padding-modal">
              

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Fecha desde"
                  >
                    <DatePicker renderExtraFooter={() => 'extra footer'} onChange={this.onClickDateFrom} placeholder="Desde:"/>
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Fecha hasta"
                  >
                    <DatePicker renderExtraFooter={() => 'extra footer'} onChange={this.onClickDateTo} placeholder="Hasta:"/>

                  </FormItem>
                </Col>

                <Col lg={4} md={4} sm={4} xs={4}>
                  <FormItem
                    label="Titulo"
                    validateStatus={this.state.validatetitle}
                    help={this.state.helptitle}
                  >
                  </FormItem>
                  </Col>
                  <Col lg={20} md={20} sm={20} xs={20}>
                    <Input
                      required
                      placeholder="Titulo"
                      value={this.state.title}
                      onChange={event => {
                        this.setState({
                          title: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validatetitle: '',
                            helptitle: '',
                          })
                        } else {
                          this.setState({
                            validatetitle: 'error',
                            helptitle: 'Titulo es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  
                </Col>

                <Col lg={4} md={4} sm={4} xs={4}>
                  <FormItem
                    label="Mensaje"
                    validateStatus={this.state.validatemessage}
                    help={this.state.helpmessage}
                  >
                  </FormItem>
                 </Col>
                 <Col lg={20} md={20} sm={20} xs={20}>
                    <TextArea rows={4} 
                      required
                      placeholder="Mensaje"
                      value={this.state.message}
                      onChange={event => {
                        this.setState({
                          message: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validatemessage: '',
                            helpmessage: '',
                          })
                        } else {
                          this.setState({
                            validatemessage: 'error',
                            helpmessage: 'Mensaje es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                 
                </Col>
                

                 <Col lg={4} md={4} sm={4} xs={4}>
                 <br/>
                 <br/>
                <FormItem
                  label="Imagen"
                  
                >
                 </FormItem>
                 </Col>
                 <Col lg={20} md={20} sm={20} xs={20}>
                 <br/>
                 <br/>
                 <input
                      type="file"
                      onChange={event => {
                        this.handlChangeImage(event.target.files)
                      }}
                    />
               
              </Col>

              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({placeStores, notifications}) {
  return {
    placeStores,
    notifications,
  }
}
export default connect(
  mapStateToProps,
  {fetchNotifications, createNotification},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Notification/Modal.js